import { InfoBox } from "@airhelp/react";
import { Text } from "@chakra-ui/react";

export function ErrorNotification({ message }: { message: string }) {
  return (
    <InfoBox variant={"danger"} borderRadius={4}>
      <Text fontWeight={500} fontSize={"md"}>
        {message}
      </Text>
    </InfoBox>
  );
}
